<div class="alerts-wrapper cg-hide-for-print" *ngIf="alert">
  <div class="alerts-inner">
    <cigna-icon type="exclamation-triangle" class="alert-icon"></cigna-icon>
    <p class="alert-text">
      <strong data-test="alert-header">{{ alert.header }}</strong>
      <span
        data-test="alert-body"
        (click)="alertClick($event)"
        [innerHtml]="alert.body"
      ></span>
    </p>
  </div>
</div>
